export const appUrl = "https://egila-e-commerce-of-backend.vercel.app/api/";
// export const appUrl = "http://localhost:5000/api/";

export const token = localStorage.getItem("token");
